import { Dispatch } from 'redux';
import { Countries, Weddings } from '@bridebook/models';
import { CountryCodes } from '@bridebook/toolbox/src/gazetteer';
import { getDocsFromCacheOrServer } from '@bridebook/web/lib/auth/utils/get-docs-from-cache-or-server';
import {
  fetchTasksInitialSuccess,
  fetchUserChecklistSuccess,
} from '@bridebook/web/lib/checklist/actions';
import { recursiveSerializeTimestamps } from '@bridebook/toolbox/src/serialize-timestamps';
import type { TTaskSerialized } from '@bridebook/web/lib/weddings/types';
import type { TCountryTaskSerialized } from '@bridebook/web/lib/countries/types';
import { filterChecklistWeddingTasks } from '@bridebook/web/lib/checklist/filter-wedding-tasks';

export const fetchChecklistData = async (
  dispatch: Dispatch<any>,
  weddingId: string,
  countryCode: CountryCodes,
) => {
  const countryTasksRef = Countries._.getById(countryCode).Tasks.reference;
  const countryTasksSnapshot = await getDocsFromCacheOrServer(countryTasksRef);
  const countryTasksData: Record<string, TCountryTaskSerialized> = {};
  countryTasksSnapshot.docs.forEach((doc) => {
    const task = doc.data();
    if (task.active === true) {
      countryTasksData[doc.id] = recursiveSerializeTimestamps(task);
    }
  });

  const weddingTasksRef = Weddings._.getById(weddingId).Tasks.reference;
  const weddingTasksSnapshot = await getDocsFromCacheOrServer(weddingTasksRef);
  const weddingTasksData: Record<string, TTaskSerialized> = {};
  weddingTasksSnapshot.docs.forEach((doc) => {
    weddingTasksData[doc.id] = recursiveSerializeTimestamps(doc.data());
  });

  // @ts-ignore FIXME
  dispatch(fetchTasksInitialSuccess(countryTasksData));
  dispatch(
    fetchUserChecklistSuccess({
      result: filterChecklistWeddingTasks(weddingTasksData),
      source: 'server',
    }),
  );
};
